// Reusable regex / validator functions

// Regex List
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Builder List
export const hasExactLength = (str, length) => str?.length === length;
export const isLengthBetween = (str, min, max) => str?.length >= min && str?.length <= max;

// Field Validators
export const validateEmail = email => emailRegex.test(email);
export const validatePostcode = code => hasExactLength(code, 5);

// Validation patterns per specification
export const validationPatterns = {
  nric: /^[0-9]{6}-[0-9]{2}-[0-9]{4}$/,
  business_registration_number: /^[0-9]{12}$/,
  passport: /^[A-Z]{1,2}[0-9]{7,9}$/,
  army: /^[A-Z0-9]{8,15}$/,
  phone: /^[0-9+\-\s()]{10,15}$/,
  postcode: /^[0-9]{5}$/,
};

export const validateNRIC = nric => validationPatterns.nric.test(nric || '');
export const validateBusinessReg = val =>
  validationPatterns.business_registration_number.test(val || '');
export const validatePassport = val => validationPatterns.passport.test(val || '');
export const validateArmy = val => validationPatterns.army.test(val || '');
export const validatePhone = val => validationPatterns.phone.test(val || '');

export function validateIdNumber(idTypeKey, value) {
  if (!idTypeKey) return false;
  const pattern = validationPatterns[idTypeKey];
  return pattern ? pattern.test(value || "") : false;
}

export const idTypeMap = {
  // Map display values (as shown in dropdown) to API keys / pattern keys
  'NRIC': 'nric',
  'BUSINESS REGISTRATION NO. (BRN)': 'business_registration_number',
  'PASSPORT': 'passport',
  'ARMY': 'army',
};

export const idValidationMessages = {
  nric: 'NRIC must match 6 digits-2 digits-4 digits (e.g., 901231-14-1234)',
  business_registration_number: 'Business Registration must be exactly 12 digits',
  passport: 'Passport number must be 1-2 letters followed by 7-9 digits (e.g., A12345678)',
  army: 'Army number must be 8-15 letters/digits (no symbols)',
};

export const phoneValidationMessage = 'Please enter a valid Malaysian phone number';
export const postcodeValidationMessage = 'Postcode must be exactly 5 digits';
